export interface DropDownInterface {
  code?: string;
  description?: string;
  sqNumber?: number;
  tlMaskInfo_sqText?: string;
}

export interface DropdownItem {
  label: string;
  value: string;
  tooltipData?: string;
}
